import request from './request.js';
import {requestbody} from './request.js'

//首页最近代办统计
export async function agentStatistics (params = {
}) {
return await request('/statistics/agentStatistics', 'post', params)
}
//本期报税进度统计
export async function periodTaxStatistics (params = {
}) {
return await request('/statistics/periodTaxStatistics', 'post', params)
}
//首页报税起止时间
export async function taxCalendar (params = {
}) {
return await request('statistics/taxCalendar', 'post', params)
}